import ResponseBodyToggle_vue_vue_type_script_setup_true_lang_default from "./ResponseBodyToggle.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ResponseBody/ResponseBodyToggle.vue
var ResponseBodyToggle_default = ResponseBodyToggle_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ResponseBodyToggle_default as default };

//# sourceMappingURL=ResponseBodyToggle.vue.js.map